import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAllEvents } from "../../redux/action/eventsAction";
import { getCurrentDateTime } from "../../helper/helper";
import { endOfMonth, startOfMonth } from "date-fns";
import DatePicker from "react-datepicker";
import { AiFillEye, AiFillEyeInvisible } from "react-icons/ai";
import { SpinLoading } from "../../modules";
import { Link } from "react-router-dom";

function Events() {
    const dispatch = useDispatch();
    const { loading, events } = useSelector((state) => state.allEvents);
    const [startDate, setStartDate] = useState(startOfMonth(new Date()));
    const [endDate, setEndDate] = useState(endOfMonth(new Date()));

    const onChange = (dates) => {
        const [start, end] = dates;
        setStartDate(start);
        setEndDate(end);
    };

    useEffect(() => {
        if (endDate) {
            dispatch(getAllEvents(startDate, endDate));
        }
    }, [dispatch, startDate, endDate]);


    return (
        <div>
            <div
                className="flex space-between align-center  pr-1 mb-1"
                style={{ marginTop: "-15px" }}
            >
                <div>
                    <b>All Events</b>
                    <span className="small-text  ">
                        &nbsp; ({startDate?.toDateString()} - {endDate?.toDateString()})
                    </span>
                </div>

                <span className="flex align-center gap-1">
                    {loading && <SpinLoading />}
                    <div className="chart-date-select btn-outline flex align-center gap-1 ">
                        <DatePicker
                            selected={startDate}
                            onChange={onChange}
                            startDate={startDate}
                            endDate={endDate}
                            selectsRange
                            className="browser-default "
                            dateFormat="dd/MM/yyyy"
                        />
                        <span className="material-symbols-outlined">calendar_month</span>
                    </div>
                </span>
            </div>
            <table>
                <thead>
                    <tr className="small-text">
                        <th>#</th>
                        <th>Event Name</th>
                        <th>Count</th>
                        <th>Action</th>
                    </tr>
                </thead>
                <tbody>
                    {events.map((item, index) => {
                        console.log(item);
                        return (
                            <tr className="small-text" key={index}>
                                <td>{index + 1}</td>
                                <td>{item._id}</td>
                                <td>{item.count}</td>
                                <Link to={`/single-event/${item._id}`} >
                                    <td> <AiFillEye className="eye-icon" /></td>
                                </Link>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    )
}

export default Events